import { createAction, props, union } from '@ngrx/store';

import { TemplateHeader } from '../../../templater-module/declarations/template-model';

export const loadSubject = createAction(
  '[NEWSLETTERS][SUBJECT] Load',
  props<{ subject: TemplateHeader }>()
);

export const clearEditorializedSubject = createAction(
  '[NEWSLETTERS][SUBJECT] Clear editorialized'
);

const templateSubjectActions = union({
  loadSubject,
  clearEditorializedSubject
});

export type TemplateSubjectAction = typeof templateSubjectActions
